import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// ai_knowledge_docs — Knowledge base documents (1 doc per row)
// ============================================================================
export const aiKnowledgeDocs = sqliteTable("ai_knowledge_docs", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  title: text("title").notNull(),
  content: text("content").notNull(),
  category: text("category"), // legacy — kept for backward compat
  tags: text("tags"), // JSON array string e.g. '["นโยบาย","FAQ"]'
  searchMode: text("search_mode").default("keyword"), // 'keyword' or 'semantic'
  isActive: integer("is_active").default(1),
  isVectorized: integer("is_vectorized").default(0),
  chunkCount: integer("chunk_count").default(0),
  // Audit fields
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type AiKnowledgeDoc = typeof aiKnowledgeDocs.$inferSelect;
export type NewAiKnowledgeDoc = typeof aiKnowledgeDocs.$inferInsert;
